import { PreviewModeToggle } from '@/pages/agents/components/modals/share-modal/SharePreview';
import { useAuth } from '@/services/auth';
import { useClientKey } from '@/state/agent';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Playground } from './Playground';

const Container = styled.div`
    height: 92%;
    width: 30%;

    margin-block: auto;
    margin-inline-end: 2%;

    border-radius: 40px;
    background: rgba(236, 234, 232, 0.75);

    @media (max-width: 1096px) {
        display: none;
    }
`;

const InnerContainer = styled.div`
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px;
`;

const PreviewModeNote = styled.div`
    display: flex;
    width: auto;
    padding: 8px 12px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: #090604;
    backdrop-filter: blur(8px);
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    margin-top: 12px;
    margin-bottom: 6px;
`;

interface Props {
    agentId: string;
}

export const PlaygroundContainerV2 = observer(({ agentId }: Props) => {
    const { isAnonymous } = useAuth();
    const [isMobile, setIsMobile] = useState(false);
    const { data: clientKey } = useClientKey({ isAnonymous });

    if (!clientKey) return;

    return (
        <Container>
            <InnerContainer>
                <PreviewModeToggle mobile={isMobile} setMobile={setIsMobile} />
                <PreviewModeNote>You’re in preview mode, sound and face animations won’t show</PreviewModeNote>
                <Playground agentId={agentId} isMobile={isMobile} clientKey={clientKey.client_key} />
            </InnerContainer>
        </Container>
    );
});
